.title {
  font-size: 12px;
  font-weight: 500;
  color: var(--bc-color-text-secondary);
}

.overlay {
  padding: 0;
  width: 320px;
}
